import { expVal } from '@atlassian/jira-feature-experiments';

const JiraSoftwareTimelineFastFollowsRelayProvider = {
	get(): boolean {
		return expVal('jira_software_timeline_fast_follows', 'isEnabled', false);
	},
};

export default JiraSoftwareTimelineFastFollowsRelayProvider;
